export default {
  // common 부분
  company: "/api/v1/user",

  //dev
  app: "/api/v1/app",
  api: "/api/v1/apis",

  // user
  userApi: "/api/v1/api",
  workflow: "/api/v1/workflow",
  group: "/api/v1/group",
  userApp: "/api/v1/userApp",

  //.통신 부분
  connection: "/api/v1/connect",
};
